import Vue from "vue";
import Vuex from "vuex";
import {
  addVendor,
  getVendor,
  putVendor,
  deleteVendor,
} from "../../utils/apiFunctions.js";
Vue.use(Vuex);

// State
const state = () => ({
  VendorDetails: [],
  sourceSelect: "",
  changeVendor: false,
});

// getters
const getters = {
  // change the data in search bar
  changeValue: (state) => state.changeVendor,

  getsaveAllVendor: (state) => {
    const sort = state.sourceSelect;

    let finalTopicDetails = [];

    // Alpha Sorting
    if (sort === "1") {
      finalTopicDetails = state.VendorDetails.slice().sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    }
    // Reverse Alpha Sorting
    else if (sort === "2") {
      finalTopicDetails = state.VendorDetails.slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .slice()
        .reverse();
    }
    // Date Sort
    else if (sort === "3") {
      finalTopicDetails = state.VendorDetails.slice().reverse();
    } else {
      finalTopicDetails = state.VendorDetails;
    }
    return finalTopicDetails;
  },
};

// actions
const actions = {
  // POST ADD Vendor API
  async saveAddVendor(state, payload) {
    let data = await payload;
    try {
      const response = await addVendor(data);
      if (response.status == 200) {
        state.commit("saveVendor", data);
      }
      return response;
    } catch (error) {
      return error;
    }
  },

  // GET VENDOR API
  async getVendor(state, data) {
    try {
      const res = await getVendor(data);
      if (res.status == 200) {
        let payload = res.data.data;
        state.commit("saveAllVendor", payload);
      }
      return res;
    } catch (error) {
      return error;
    }
  },

  // EDIT VENDOR API
  async editVendor({ commit }, payload) {
    try {
      const response = await putVendor(payload);
      if (response.status == 200) {
        commit("editCurrentVendor", payload);
      }
      return response;
    } catch (error) {
      throw new Error(`Update Vendor Failed! status: ${error.status}`);
    }
  },

  // DELETE VENDOR API
  async deleteVendor({ commit }, payload) {
    try {
      let data = { vendorID: payload.vendorID };
      const response = await deleteVendor(data);
      if (response.status == 200) {
        commit("deleteCurrentVendor", payload);
      }
      return response;
    } catch (error) {
      throw new Error(`Delete Vendor Failed! status: ${error.status}`);
    }
  },
};

// mutations
const mutations = {
  // get value
  newvendorValue(state, payload) {
    state.changeVendor = payload;
  },

  // add Vendor
  saveVendor(state, payload) {
    state.VendorDetails.push(payload);
  },

  // GET VENDOR
  saveAllVendor(state, payload) {
    state.VendorDetails = payload;
  },

  // EDIT VENDOR
  editCurrentVendor(state, payload) {
    for (let i in state.VendorDetails) {
      if (state.VendorDetails[i].vendorID === payload.vendorID) {
        // Copying the OBJECT using object spread
        state.VendorDetails[i] = { ...payload };
      }
    }
  },

  // DELETE CUSTOMER
  deleteCurrentVendor(state, payload) {
    state.VendorDetails = state.VendorDetails.filter(
      (data) => data.vendorID != payload.vendorID
    );
  },
  // sort commit
  sourceSelected(state, payload) {
    state.sourceSelect = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
